module.exports = __webpack_public_path__ + "static/Logo-masterbots-cc21ccc796fbfa10e657232e76e21a51.svg";